export default "__VITE_ASSET__Dqx4atih__"